import { render, staticRenderFns } from "./PCurve.vue?vue&type=template&id=5884711b&"
import script from "./PCurve.vue?vue&type=script&lang=js&"
export * from "./PCurve.vue?vue&type=script&lang=js&"
import style0 from "./PCurve.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports